import React from "react";
 

const FancyButton = React.forwardRef((props, ref) => <div ref={ref}  style={{display: "flex" , justifyContent : "center" }}/>);
export default FancyButton;

